import { defaultApi } from '@/api';

export interface TenantEntities {
  groups: { id: number; name: string }[];
  viewers: {
    id: number;
    name: string;
    lastname: string;
    email: string;
    isOwner?: boolean;
    isEditable?: boolean;
  }[];
}

export async function getTenantEntities() {
  const { data } = await defaultApi.get<TenantEntities & { maxUsers: number }>('/tenant/entities');
  return data;
}

export async function createSaml2Tenant(
  entityId: string,
  loginUrl: string,
  logoutUrl: string,
  x509certificate: string
) {
  const { data } = await defaultApi.post<{
    metadata: string;
    acs: string;
    sls: string;
    loginUrl: string;
    logoutUrl: string;
  }>('/saml2', {
    entityId,
    loginUrl,
    logoutUrl,
    x509certificate,
  });
  return data;
}

export async function getSaml2Settings() {
  const { data } = await defaultApi.get<{
    acs: string;
    metadata: string;
    saml2LoginUrl: string;
    entityId: string;
    loginUrl: string;
    logoutUrl: string;
    x509certificate: string;
  }>('/saml2');
  return data;
}
